export const environment = {
  production: true,
  buildId: '3993563422324221',
  configFile: 'config.json',
};
